import type { Pagination } from '@pba/react-query';
import { generateQueryKey } from 'query';
import type { GlobalSearchFilter } from './useGlobalSearchInfiniteQuery';
import type { GlobalSearchInputFilter } from './useGlobalSearchInputQuery';

export const getGlobalSearchFeatureQueryKey = () => generateQueryKey(['globalSearch']);

type GlobalSearchInputParams = {
  filter?: GlobalSearchInputFilter;
};

type GlobalSearchParams = {
  filter?: GlobalSearchFilter;
  pagination?: Partial<Pagination>;
};

export const getGlobalSearchQueryKey = ({ filter = {}, pagination = {} }: GlobalSearchParams) =>
  generateQueryKey([...getGlobalSearchFeatureQueryKey(), { filter, pagination }]);

export const getGlobalSearchInputQueryKey = ({ filter = {} }: GlobalSearchInputParams) =>
  generateQueryKey([...getGlobalSearchFeatureQueryKey(), 'input', { filter }]);

export const getRecentSearchesQueryKey = () => generateQueryKey([...getGlobalSearchFeatureQueryKey(), 'recent']);
